import { Injectable } from '@angular/core';
import { NgxsActionName } from '@shared/constants';
import { DMPRole, KPINameNameIdMapping } from '@shared/enums';
import { UserProfile } from '@shared/classes/user-profile';
import { BaseColumn } from '@shared/classes/base-column';
import { DrivingBehavior } from '@shared/classes/driving-behavior';
import { KpiSafety } from '@shared/classes/kpi-safety';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  constructor() { }

  public checkEditable(functionName: string, role: DMPRole) {
    if (functionName === NgxsActionName.GET_ORG_UNIT || functionName === NgxsActionName.GET_USER_PROFILE || functionName === NgxsActionName.GET_KPI_CONFIGURATION) {
      if (role === DMPRole.DRIVER_ADMIN) {
        return false;
      }
    }

    return true;
  }

  public checkDriverAdminContainsOtherUsersData(userProfile: UserProfile, selectedItems: BaseColumn[]) {
    if (userProfile.role.role_Id === DMPRole.DRIVER_ADMIN) {
      if (this.checkIsKpiSafety(selectedItems[0] as KpiSafety)) {
        return false;
      }

      return selectedItems.filter(selectedItem => selectedItem.created_By !== userProfile.apexId).length > 0;
    }

    return false;
  }

  public checkIsDrivingBehavior(selectedItem: DrivingBehavior) {
    return selectedItem && selectedItem.kpiDrivingBehavior_Id !== null && selectedItem.kpiDrivingBehavior_Id !== undefined;
  }

  public checkIsKpiSafety(selectedItem: KpiSafety) {
    return selectedItem && selectedItem.kpiSafty_Id !== null && selectedItem.kpiSafty_Id !== undefined;
  }

  public checkDriverBehaviorIsDriverObservationKpi(selectedItem: DrivingBehavior) {
    return selectedItem.kpi && selectedItem.kpi.kpiId === KPINameNameIdMapping.DRIVER_OBSERVATION;
  }
}
